import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Card, CardContent, Container, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import * as yup from "yup";
import { Button, Input } from "../../../components";
import { changePassword_V2 } from "../../../Services_V2/Auth.service";
import { showError } from "../../../utils/error";

type SchemaType = {
  oldPassword: string;
  password: string;
  confirmPassword: string;
};

const schema = yup.object().shape({
  oldPassword: yup.string().required("Old Password is required"),
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*])/,
      "Password must contain at least one letter, one number, and one special character"
    ),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), ""], "Passwords must match")
    .required("Confirm Password is required"),
});

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<SchemaType>({
    resolver: yupResolver(schema),
  });

  const onSubmit = useCallback(
    async (data: SchemaType) => {
      setLoading(true);
      try {
        const res = await changePassword_V2({
          oldPassword: data.oldPassword,
          newPassword: data.password,
        });
        if (res?.success) {
          toast.success(res?.message);
          reset();
        }
      } catch (error) {
        showError(error);
      } finally {
        setLoading(false);
      }
    },
    [reset]
  );

  return (
    <Container
      maxWidth="sm"
      sx={{ height: "calc(100vh - 80px)", alignContent: "center" }}
    >
      <Card sx={{ boxShadow: 3, borderRadius: 2 }}>
        <CardContent sx={{ p: 4 }}>
          <Typography
            variant="h5"
            component="h2"
            align="center"
            gutterBottom
            fontWeight={600}
          >
            Reset Password
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit(onSubmit)}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              mt: 2,
            }}
          >
            <Input
              type="password"
              fullWidth
              label="Old Password"
              {...register("oldPassword")}
              error={!!errors?.oldPassword}
              helperText={errors?.oldPassword?.message}
            />
            <Input
              type="password"
              fullWidth
              label="New Password"
              {...register("password")}
              error={!!errors?.password}
              helperText={errors?.password?.message}
            />
            <Input
              type="password"
              fullWidth
              label="Confirm New Password"
              {...register("confirmPassword")}
              error={!!errors?.confirmPassword}
              helperText={errors?.confirmPassword?.message}
            />
            <Button
              type="submit"
              fullWidth
              loading={loading}
              variant="contained"
              size="large"
            >
              Change Password
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default ResetPassword;
